import { CustomState, IWorkflowItem } from '@interfaces/interfaces';
import { WorkflowItemStatus } from '@api/projects/interfaces';

export type WFSState = Omit<CustomState, 'id'>  & { disabled?: true; };

export const UNTOUCHED_STARTABLE: WFSState = {
	label: 'status.unstarted',
	symbol: 'play-circle',
	color: '#7a7a7a',
	colorShouldBeBackground:false
};

export const UNTOUCHED_LOCKED: WFSState = {
	label: 'status.locked',
	symbol: 'stop',
	color: '#7a7a7a',
	colorShouldBeBackground:true,
	disabled: true,
};

export const STARTED: WFSState = {
	label: 'status.started',
	symbol: 'play-circle',
	color: '#009ed5',
	colorShouldBeBackground: true,
};

export const FINISHED: WFSState = {
	label: 'status.finished',
	symbol: 'check-circle',
	color: '#208000',
	colorShouldBeBackground: true,
};

export const HAS_OPEN_QUERIES: WFSState = {
	label: 'status.queries.open',
	symbol: 'alert',
	color: 'rgb(182, 0, 0)',
	colorShouldBeBackground: true,
};

export const HAS_RESPONDED_QUERIES: WFSState = {
	label: 'status.queries.responded',
	symbol: 'comment',
	color: 'rgb(182, 0, 0)',
	colorShouldBeBackground: true,
};

export function getStatusTemplate(item: IWorkflowItem | null, info: WorkflowItemStatus | null): WFSState {
	if (!item) {
		return UNTOUCHED_LOCKED;
	} else if (!info) {
		return UNTOUCHED_STARTABLE;
	} else if (!(info.startable ?? true)) {
		return UNTOUCHED_LOCKED;
	} else if (info.queryStats?.opened > 0) {
		return HAS_OPEN_QUERIES;
	} else if (info.queryStats?.responded > 0) {
		return HAS_RESPONDED_QUERIES;
	} else if (info.customState) {
		return item?.customStates.find(cState => cState.id === info?.customState) ?? STARTED;
	} else if (info?.started) {
		return STARTED;
	} else if (info?.completed) {
		return FINISHED;
	} else {
		return UNTOUCHED_STARTABLE;
	}
}
